<template>
	<div class="pa-2 warning lighten-3">
		<div>
			<strong>{{conflict.score}}%</strong>
			- Conflict with <strong>{{language}}</strong> content
			<strong>{{conflict.res.name}}
				<span v-if="conflict.res.code">({{conflict.res.code}})</span>
			</strong>
		</div>
		<div>{{conflict.text}}</div>
	</div>
</template>

<script>

import locales from '@/datasources/locales'

export default {
	props: {
		conflict: {
			type: Object,
			default: () => ({
				locale: '',
				score: 0,
				res: {
					name: '',
					code: null,
				},
				text: '',
			}),
		},
	},
	computed: {
		language() {
			if (!this.conflict.locale || this.conflict.locale === '') { return 'not found' }

			const locale = locales[this.conflict.locale]
			return locale && locale.name ? locale.name.toLowerCase() : 'not found'
		},
	},
}
</script>
